import {
  Accessibility,
  Beer,
  Coffee,
  CupSoda,
  DoorClosed,
  DoorOpen,
  GlassWater,
  Globe,
  HelpCircle,
  Info,
  LucideIcon,
  Mail,
  MapPin,
  Martini,
  Users,
  Utensils,
  Wine,
} from "lucide-react";

export const ICON_TYPES = [
  "info",
  "accessibility",
  "helpCircle",
  "users",
  "doorOpen",
  "doorClosed",
  "martini",
  "utensils",
  "cupSoda",
  "beer",
  "coffee",
  "wine",
  "glassWater",
  "mapPin",
  "mail",
  "globe",
] as const;

export const ICON_MAP: Record<string, LucideIcon> = {
  info: Info,
  doorClosed: DoorClosed,
  doorOpen: DoorOpen,
  accessibility: Accessibility,
  users: Users,
  helpCircle: HelpCircle,
  utensils: Utensils,
  cupSoda: CupSoda,
  beer: Beer,
  coffee: Coffee,
  wine: Wine,
  glassWater: GlassWater,
  martini: Martini,
  mapPin: MapPin,
  mail: Mail,
  globe: Globe,
} as const;
